__webpack_require__.p = "/reports-campaign-analytics/system-email-templates/";